import { render } from "./TaskComponent.vue?vue&type=template&id=38789539&scoped=true"
import script from "./TaskComponent.vue?vue&type=script&lang=js"
export * from "./TaskComponent.vue?vue&type=script&lang=js"

import "./TaskComponent.vue?vue&type=style&index=0&id=38789539&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38789539"]])

export default __exports__